export const loginTypes = {
	REQUEST: "LOGIN_REQUEST",
	SUCCESS: "LOGIN_SUCCESS",
	FAILURE: "LOGIN_FAILURE",

	LOGOUT: "LOGOUT",

	UPDATE_USERNAME_PASSWORD: "UPDATE_USERNAME_PASSWORD",

	LOADING_LOGIN: "LOADING_LOGIN"
};
